
const styles = {
    heading: { color: "#3F3F46", fontSize: "20px", fontWeight: '600', textAlign: "center" },
    subheading: { color: "#3F3F46", fontSize: "14px", fontWeight: '300', marginBottom: "0.2em", textAlign: "center" }
};

export default styles;